import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import StatusBadge from 'ui-component/StatusBadge';
import { getCurrencySymbolV2, numberFormatter } from 'utils/currency';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import usePermissions from 'hooks/usePermissions';
import useIsMobile from 'utils/isMobileUtils';


const SalesOrderComponent = ({ details, viewedBy = 'ADMIN' }) => {
    const [allPermissions, hasEveryPermission] = usePermissions();
    const history = useNavigate();
    const isMobile = useIsMobile();
    const selectedCurrency = useSelector((state) => state.main.selectedCurrency);
    const [defaultCurrency, setDefaultCurrency] = useState(details?.sales_order?.currency || 'usd');

    const handleOpenNewTab = (pageModule, id, ref) => {

        let url = '';
        if (pageModule == 'products') {
            url = viewedBy === 'ADMIN' ? `/products/${id}` : `/client/products/${id}`;
        } else if (pageModule == 'contacts') {
            url = `/contacts/${id}`;
        } else if (pageModule == 'purchase_orders') {
            url = `/purchasing/view/${id}`;
        } else if (pageModule == 'sales_orders') {
            url = viewedBy === 'ADMIN' ? `/sales/sales-orders/${id}?ref=${ref}` : `/client/sales-orders/${id}?ref=${ref}`;
        } else if (pageModule == 'invoices') {
            url = viewedBy === 'ADMIN' ? `/sales/invoices/${id}?ref=${ref}` : `/client/invoices/${id}?ref=${ref}`;
        } else if (pageModule == 'quotations') {
            url = viewedBy === 'ADMIN' ? `/sales/quotations/${id}?ref=${ref}` : `/client/quotations/${id}?ref=${ref}`;
        }
        if (url) {
            history(url);
        }
    };

    return (
        
        !isMobile ? (
            <div style={{ padding: '0px 20px 20px 16px' }}>
                <div className="row mb10">
                    <div className="col-12">
                        <h2 className="d-flex font600" style={{ fontSize: '18px' }}>Sales Order</h2>
                    </div>
                </div>
                <div className="row">
                    {
                        viewedBy === 'ADMIN' ? (
                            <>
                                <div className="col-md-2 font600">SO #</div>
                                <div className="col-md-4 font600">Customer</div>
                                <div className="col-md-2 font600">Date</div>
                                <div className="col-md-2 font600">Status</div>
                                <div className="col-md-2 font600">Total</div>
                            </>
                        ) : (
                            <>
                                <div className="col-md-4 font600">SO #</div>
                                <div className="col-md-4 font600">Date</div>
                                {/* <div className="col-md-3 font600">Total</div> */}
                                <div className="col-md-4 font600">Status</div>
                            </>
                        )
                    }
                </div>
                <hr className="mt8 mb8" />
                <div className="row">
                    {
                        viewedBy === 'ADMIN' ? (
                            <>
                                <div className="col-md-2 d-flex align-items-center">
                                    <div
                                        className={`${hasEveryPermission(['View Sales Orders Details']) ? 'text-primary cursor-pointer' : ''}`}
                                        onClick={() => {
                                            if (hasEveryPermission(['View Sales Orders Details'])) {
                                                handleOpenNewTab('sales_orders', details?.sales_order?.id, details?.sales_order?.ref);
                                            }
                                        }}
                                    >
                                        {details?.sales_order?.sales_order_number}
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    <div
                                        className={`${hasEveryPermission(['View Contact Details (Page)']) ? 'text-primary cursor-pointer' : ''}`}
                                        onClick={() => {
                                            if (hasEveryPermission(['View Contact Details (Page)'])) {
                                                handleOpenNewTab('contacts', details?.sales_order?.customer?.id, details?.sales_order?.ref)
                                            }
                                        }}
                                    >
                                        {details?.sales_order?.customer?.name}
                                    </div>
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                                    {moment(details?.sales_order?.accepted_on ?? details?.sales_order?.start_at).format(CommonDateOnlyFormat)}
                                </div>
                                <div className="col-md-2 ">
                                    <div style={{ width: '90px' }}>
                                        <StatusBadge itemStatus={details?.sales_order?.status} />
                                    </div>
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                                    <div className="flex gap-1 w-full">
                                        
                                        <div style={{ marginTop: `${selectedCurrency === 'aed' ? '-1px' : '0'}` }}>
                                            {getCurrencySymbolV2(selectedCurrency, details?.sales_order?.currency, '11px', '11px')}
                                        </div>
                                        <div>
                                            {details?.sales_order?.converted_currency_total ? numberFormatter.format(details?.sales_order?.converted_currency_total[selectedCurrency === 'all' ? defaultCurrency : selectedCurrency]) : 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="col-md-4 d-flex align-items-center">
                                    <div
                                        className={`text-primary cursor-pointer`}
                                        onClick={() => {
                                            handleOpenNewTab('sales_orders', details?.sales_order?.sales_order_number, details?.sales_order?.ref);
                                        }}
                                    >
                                        {details?.sales_order?.sales_order_number}
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    {moment(details?.sales_order?.accepted_on ?? details?.sales_order?.start_at).format(CommonDateOnlyFormat)}
                                </div>
                                <div className="col-md-4 ">
                                    <div style={{ width: '90px' }}>
                                        <StatusBadge itemStatus={details?.sales_order?.status} />
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
                <hr className="mt8 mb8" />
            </div>
        ) : (
            <div
                style={{ display: 'flex', flexDirection: 'column' }}
                onClick={() => {
                    if (viewedBy === 'ADMIN') {
                        handleOpenNewTab('sales_orders', details?.sales_order?.id, details?.sales_order?.ref);
                    } else {
                        handleOpenNewTab('sales_orders', details?.sales_order?.sales_order_number, details?.sales_order?.ref);
                    }
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                    <h2 className="d-flex font500" style={{ fontSize: '17px', marginBottom: 0 }}>
                        Sales Order
                    </h2>
                    <div>
                        <div style={{ width: '90px' }}>
                            <StatusBadge itemStatus={details?.sales_order?.status} />
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: 5, alignItems: 'center', fontWeight: 500, fontSize: 13 }}>
                        SO #:
                        <div
                            className={`text-primary cursor-pointer`}
                        >
                            {details?.sales_order?.sales_order_number}
                        </div>
                    </div>
                    <div>
                        {moment(details?.sales_order?.accepted_on ?? details?.sales_order?.start_at).format(CommonDateOnlyFormat)}
                    </div>
                </div>
                {
                    viewedBy === 'ADMIN' && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 500, fontSize: 14 }}>
    
                            <div
                                className={`${hasEveryPermission(['View Contact Details (Page)']) ? 'text-primary cursor-pointer' : ''}`}
                                onClick={() => {
                                    if (hasEveryPermission(['View Contact Details (Page)'])) {
                                        handleOpenNewTab('contacts', details?.sales_order?.customer?.id, details?.sales_order?.ref)
                                    }
                                }}
                            >
                                {details?.sales_order?.customer?.name}
                            </div>
                            <div style={{ fontWeight: 500 }}>
                                <div className="flex gap-1 w-full">
                                    
                                    <div style={{ marginTop: `${selectedCurrency === 'aed' ? '-1px' : '0'}` }}>
                                        {getCurrencySymbolV2(selectedCurrency, details?.sales_order?.currency, '11px', '11px')}
                                    </div>
                                    <div>
                                        {details?.sales_order?.converted_currency_total ? numberFormatter.format(details?.sales_order?.converted_currency_total[selectedCurrency === 'all' ? defaultCurrency : selectedCurrency]) : 'N/A'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        )
    );
};

export default SalesOrderComponent;
